export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.tiers = this.resolve.tiers;
    }

    processTierParam(param) {
        if(param === false || param === 0) {
            return '<i class="fa fa-minus" />';
        }
        if(param === true) {
            return '<i class="fa fa-check" />';
        }
        return param;
    }

    processBillingInterval(interval) {
        if(interval == 1) {
            return 'Monthly'
        } else if(interval == 12) {
            return '1 Year'
        } else if(interval == 24) {
            return '2 Years'
        } else if(interval == 36) {
            return '3 Years'
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/tier-details/license-tier-details.controller.js